module.exports = __webpack_public_path__ + "img/mobile_publications_img.73332287.jpg";